/**
 * Iter 97 — shared bits for the mobile Pickup / Drop-off wizards.
 */
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export const FUEL_LEVELS = ["Full", "3/4", "1/2", "1/4", "Empty"];

export function WizardShell({ open, onClose, title, step, steps, children, testId }) {
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent side="bottom" className="rounded-t-3xl h-[92vh] flex flex-col p-0" data-testid={testId}>
        <SheetHeader className="px-5 pt-5 pb-3 border-b border-border">
          <SheetTitle className="text-left text-lg">{title}</SheetTitle>
          <div className="flex gap-1.5 mt-1">
            {steps.map((s, i) => (
              <div key={s} className={`h-1.5 flex-1 rounded-full ${i <= step ? "bg-blue-600" : "bg-neutral-200"}`} />
            ))}
          </div>
          <div className="text-xs text-neutral-500 font-semibold">Step {step + 1} of {steps.length} — {steps[step]}</div>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
      </SheetContent>
    </Sheet>
  );
}

export function WizardNav({ step, lastStep, onBack, onNext, nextLabel = "Next", nextDisabled = false, busy = false, nextTestId }) {
  return (
    <div className="sticky bottom-0 -mx-5 px-5 py-3 bg-white border-t border-border flex gap-2 mt-4">
      {step > 0 && (
        <button
          type="button"
          onClick={onBack}
          className="flex-1 rounded-xl border border-border bg-white text-sm font-bold py-3.5"
          data-testid="wizard-back"
        >
          Back
        </button>
      )}
      <button
        type="button"
        onClick={onNext}
        disabled={nextDisabled || busy}
        className={`flex-[2] rounded-xl text-white text-sm font-bold py-3.5 transition ${
          step === lastStep ? "bg-emerald-600" : "bg-neutral-900"
        } disabled:opacity-50`}
        data-testid={nextTestId || "wizard-next"}
      >
        {busy ? "Saving…" : nextLabel}
      </button>
    </div>
  );
}

export function FuelPicker({ value, onChange, testIdPrefix = "fuel" }) {
  return (
    <div className="grid grid-cols-5 gap-1.5">
      {FUEL_LEVELS.map((f) => (
        <button
          key={f}
          type="button"
          onClick={() => onChange(f)}
          className={`rounded-xl border py-3 text-xs font-bold transition ${
            value === f ? "bg-neutral-900 text-white border-neutral-900" : "bg-white border-border text-neutral-600"
          }`}
          data-testid={`${testIdPrefix}-${f.replace("/", "-")}`}
        >
          {f}
        </button>
      ))}
    </div>
  );
}

export function Row({ label, value, strong = false }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-dashed border-border last:border-0">
      <span className="text-sm text-neutral-500">{label}</span>
      <span className={`text-sm ${strong ? "font-bold" : "font-semibold"}`}>{value}</span>
    </div>
  );
}
